/**
 * Maps an array of data items to a template.
 * @param {Array} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapDataToTemplate = (results, $itemTemplate) => (
    results.map(entry => {
        const $item = $itemTemplate.clone();
        const $childTemplate = $item.find('[data-child-template]')
            .removeAttr('[data-child-template]')
            .detach();
        const $anchorLinkTemplate = $item.find('[data-anchor-link-template]')
            .removeAttr('[data-anchor-link-template]')
            .detach();

        $item.find('[data-name]').text(entry.name);
        $item.find('[data-title]').text(`[${entry.id}] ${entry.title}`);
        $item.find('[data-text]').html(entry.text);
        if (entry.image === entry.mobileImage || entry.mobileImage === undefined) {
            $item.find('[data-img]').attr('src', entry.image);
        } else {
            $item.find('[data-img]').attr('src', entry.image);
            $item.find('[data-mobileImg]').attr('srcset', `${entry.mobileImage}`);
        }
        $item.find('[data-img]').attr('alt', entry.name);

        if (entry.discontinued) {
            $item.find('[data-link]').remove();
        } else {
            $item.find('[data-discontinued]').remove();
            $item.find('[data-link]').attr('href', entry.url);
        }
        $item.addClass(entry.color);

        // map anchor links to item
        const anchorLinks = entry.anchorLinks.map((anchorLink) => {
            if (anchorLink.link && anchorLink.title) {
                const $anchorLink = $anchorLinkTemplate.clone();
                $anchorLink.attr('href', anchorLink.link);
                $anchorLink.find('span').html(anchorLink.title);
                return $anchorLink.get(0);
            }

            return null;
        }).filter(elem => elem);

        $item.find('[data-anchor-links]').append(anchorLinks);

        // map groups to child templates
        const groups = entry.groups.map((group) => {
            const $child = $childTemplate.clone();
            $child.find('[data-child-name]').text(group.name);
            $child.find('[data-child-img]').attr('src', group.image);
            $child.find('[data-child-link]').attr('href', group.url);
            return $child.get(0);
        });

        $item.find('[data-groups]').append(groups);

        return $item.get(0);
    })
);

export default mapDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/products/mapDataToTemplate.js